import React, { useState, useEffect } from "react";
import { motion } from "motion/react";

export default function CyclingTypewriter({
  phrases,
  typingSpeed = 100,
  deletingSpeed = 50,
  delayBetween = 2000,
}) {
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [currentText, setCurrentText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    const fullPhrase = phrases[currentPhraseIndex];

    const executionSpeed = isDeleting ? deletingSpeed : typingSpeed;

    const handleType = () => {
      if (!isDeleting) {
        setCurrentText(fullPhrase.substring(0, currentText.length + 1));

        // If the full phrase is typed out, pause, then switch to deleting mode
        if (currentText === fullPhrase) {
          timer = setTimeout(() => setIsDeleting(true), delayBetween);
          return;
        }
      } else {
        setCurrentText(fullPhrase.substring(0, currentText.length - 1));

        if (currentText === "") {
          setIsDeleting(false);
          setCurrentPhraseIndex(
            (prevIndex) => (prevIndex + 1) % phrases.length
          );
          return;
        }
      }

      timer = setTimeout(handleType, executionSpeed);
    };

    timer = setTimeout(handleType, executionSpeed);

    return () => clearTimeout(timer);
  }, [
    currentText,
    isDeleting,
    currentPhraseIndex,
    phrases,
    typingSpeed,
    deletingSpeed,
    delayBetween,
  ]);

  return (
    <div>
      Hi, I'm William. {currentText}
      <motion.span
        animate={{ opacity: [0, 1, 0] }}
        transition={{ repeat: Infinity, duration: 0.8, ease: "linear" }}
        className="inline-block w-[3px] h-[1em] bg-indigo-600 ml-1 translate-y-1"
      />
    </div>
  );
}
